/** @typedef {(eventName: string, context: Record<string, unknown>) => void} PersistenceReporter */

import { redactObject } from '../telemetry/redaction';

/** @type {PersistenceReporter} */
export function createNoOpPersistenceReporter() {
  return () => {};
}

/**
 * Privacy-safe local reporter for persistence telemetry events.
 * Development only: redacted console diagnostics.
 *
 * @returns {PersistenceReporter}
 */
export function createLocalRedactedPersistenceReporter() {
  return (eventName, context) => {
    if (process.env.NODE_ENV === 'production') {
      return;
    }
    const safeContext = redactObject({
      event: eventName,
      ...context,
    });
    // eslint-disable-next-line no-console
    console.info('[persistence-telemetry]', safeContext);
  };
}

/**
 * @param {PersistenceReporter | undefined | null} reporter
 * @returns {PersistenceReporter}
 */
export function resolvePersistenceReporter(reporter) {
  return typeof reporter === 'function' ? reporter : createNoOpPersistenceReporter();
}

/**
 * @param {PersistenceReporter} reporter
 * @param {string} eventName
 * @param {Record<string, unknown>} context
 */
export function safeReport(reporter, eventName, context) {
  try {
    reporter(eventName, context);
  } catch {
    // Reporter failures must not alter facade storage contract.
  }
}
